import {useAuthContext} from "../contexts/AuthenticationContext";
import {User} from "../util/Interfaces";
import {useTranslation} from "react-i18next";
import React from "react";
import SiteWrapper from "../SiteWrapper.react";
import PhaseService from "../services/phase.service";
import {useFormik} from "formik";
import {confirmAlert} from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ProjectTypeService from "../services/projectType.service";
import ElementTypeService from "../services/elementType.service";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  Box, Card, CardActions, CardContent, Chip, Collapse, Container, Grid, IconButton,
  MenuItem, Paper, Select, Stack, SvgIcon, Typography
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import { TrueffortButton, TrueffortChip, TrueffortConfirmAlert, TrueffortTextField
  } from "../MUIstyle/MUICustom";
import {Cancel as CancelIcon, Assignment as AssignmentIcon, AppRegistration as AppRegistrationIcon,
  ArrowDropDown as ArrowDropDownIcon, ArrowRight as ArrowRightIcon, Delete as DeleteIcon,
  Save as SaveIcon, Check as CheckIcon
} from '@mui/icons-material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFolderTree} from "@fortawesome/free-solid-svg-icons/faFolderTree";
import TaskTypeService from "../services/taskType.service";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ID_INSTANCE_SPINGERE } from "../util/Constants";

interface FormType {
    name: string;
    //estimatedDays?: number;
    //estimatedTime?: number;
}

function CollapsibleTask({ t, taskType, idPhaseType, taskTypeService, fillElementTypes, isModifiable, activePhaseType }: any) {
    const [edited, setEdited] = React.useState(false);

    React.useEffect(() => {
        formikTask.setValues(
            {
                name: taskType.name,
                //estimatedDays: taskType.estimatedDays,
                //estimatedTime: taskType.estimatedTime
            }
        );
        setEdited(false);
    }, [taskType]);

    const validate = (values: FormType) => {
        let errors: any = {};
        if (!values.name) {
            errors.name = "Required";
        }
        /*if (isNaN(Number(values.estimatedTime)) || Number(values.estimatedTime) < 0 || !/[0-9]+/.test(values.estimatedTime + '')) {
            errors.estimatedTime = "Only positive numeric values"
        }
        if (isNaN(Number(values.estimatedDays)) || Number(values.estimatedDays) < 0 || !/[0-9]+/.test(values.estimatedDays + '')) {
            errors.estimatedDays = "Only positive numeric values"
        }*/

        return errors;
    }

    const formikTask = useFormik({
        initialValues: {
            name: taskType.name,
            //estimatedDays: taskType.estimatedDays,
            //estimatedTime: taskType.estimatedTime
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitUpdate(values);
        }
    });

    const handleSubmitUpdate = (values: any) => {
        console.log("handleSubmitUpdate");
        let taskAux = {
            name: values.name,
            //estimatedDays: values.estimatedDays,
            //estimatedTime: values.estimatedTime,
            phase: {
                idPhase: idPhaseType
            }
        }

        // @ts-ignore
        taskTypeService.update(taskType.idTaskType, taskAux).then(({data : response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                //props._addMessage("danger", response.message);
                toast.error(response.message);
            } else {
                //props._addMessage("success", t("project_page.msg_success_task_update"));
                toast.success(t("project_page.msg_success_task_update"));
                fillElementTypes();
            }
            setEdited(false);
            formikTask.setSubmitting(false);
        });
    }

    const deleteTask = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <TrueffortConfirmAlert
                        title={
                            <Typography color='error' fontSize='18px' fontWeight={700} marginBottom='20px' >
                                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("project_page.msg_delete_task_confirm1")}
                            </Typography>
                        }
                        alertColor='error'
                        message={t("project_page.msg_delete_task_confirm2") + "" + taskType.name + "?"}
                        buttons={[
                            {
                                label: t("cancel"),
                                onClick: () => onClose()
                            },
                            {
                                label: t("accept"),
                                onClick: () => {
                                    try {
                                        // @ts-ignore
                                        taskTypeService.delete(taskType.idTaskType).then(({data : response}) => {
                                            if (response.success) {
                                                toast.success(t("project_page." + response.data));
                                                fillElementTypes();
                                            } else {
                                                toast.error("No fue posible eliminar la tarea.");
                                            }
                                        }).catch(function (error: any) {
                                            toast.error("Ocurrió un error al eliminar la tarea.");
                                        });
                                    } catch (error) {
                                        console.log("Error #Users handleDelete" + JSON.stringify(error));
                                        toast.error("Ocurrió un error al eliminar la tarea.");
                                    }

                                    onClose();
                                }
                            }
                        ]}
                    />
                );
            }
        });
    }

    const activateTask = () => {
        // @ts-ignore
        taskTypeService.activate(taskType.idTaskType).then(({data: response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.phase_activated"));
            }

            fillElementTypes();
        });
    }

    /*const newEditingValues = (values: FormType) => {
        const campos: (keyof FormType)[] = Object.keys(values) as Array<keyof FormType>;
        for (let i = 0; i < campos.length; i++) {
            if (taskType[campos[i]] !== values[campos[i]]) {
                return true;
            }
        }

        return false
    }*/

    const handleNameChange = (e: any) => {
        formikTask.handleChange(e);
        //setTaskName(e.target.value);

        /*if (!edited && newEditingValues({...formikTask.values, name: e.target.value})) {
            setEdited(true);
        } else if (edited && !newEditingValues({...formikTask.values, name: e.target.value})) {
            setEdited(false);
        }*/

        if (!edited && taskType.name !== e.target.value) {
            setEdited(true);
        } else if (edited && taskType.name === e.target.value) {
            setEdited(false);
        }
    }

    /*const handleEstimateChange = (e: any, estimateField: string) => {
        let newEstimate: number= 0;

        if (!isNaN(Number(e.target.value)) && !Number.isInteger(Number(e.target.value))) {
            newEstimate = Math.ceil(e.target.value);
            formikTask.setFieldValue(estimateField, newEstimate);
        } else {
            formikTask.handleChange(e);
            newEstimate = e.target.value;
        }

        let jsonString= '{ "' + estimateField + '" : '  + newEstimate + '}'

        if (!edited && newEditingValues({ ...formikTask.values, ...JSON.parse(jsonString) })) {
            setEdited(true);
        } else if (edited && !newEditingValues({ ...formikTask.values, ...JSON.parse(jsonString) })) {
            setEdited(false);
        }

    }*/

    return(
        <Paper
            component="form"
            onSubmit={formikTask.handleSubmit}
            variant="outlined"
            square
            sx={{ padding: '10px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
        >
            <Grid container spacing={1} >
                <Grid item xs={1} ></Grid>
                <Grid item xs={11}  >
                    <Stack direction="row" spacing={3} alignItems="center" >
                        <TrueffortTextField
                            name="name"
                            size="small"
                            required
                            disabled={!isModifiable || !taskType.active}
                            value={formikTask.values.name}
                            onBlur={formikTask.handleBlur}
                            onChange={handleNameChange}
                            error={Boolean(formikTask.errors?.name && formikTask.touched?.name)}
                        />

                        {/*<Stack direction="row" spacing={1} alignItems="center">
                            <Typography >
                                {t("project_page.initial_effort")}:
                            </Typography>
                            <TextField
                                name="estimatedTime"
                                sx={{ width: '89px' }}
                                type="number"
                                size="small"
                                InputProps={{ inputProps: { min: 1, style: { background:'#F5F5F5' } } }}
                                disabled={!isModifiable || !taskType.active}
                                onBlur={formikTask.handleBlur}
                                value={formikTask.values.estimatedTime}
                                onChange={(event: any) => handleEstimateChange(event, "estimatedTime")}
                                error={Boolean(formikTask.errors?.estimatedTime && formikTask.touched?.estimatedTime)}
                            />
                            <Typography >
                                {t("estimation_page.man_hours")}
                            </Typography>
                        </Stack>

                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography >
                                {t("project_page.initial_duration")}:
                            </Typography>
                            <TextField
                                name="estimatedDays"
                                sx={{ width: '89px' }}
                                type="number"
                                size="small"
                                InputProps={{ inputProps: { min: 1, style: { background:'#F5F5F5' } } }}
                                disabled={!isModifiable || !taskType.active}
                                onBlur={formikTask.handleBlur}
                                value={formikTask.values.estimatedDays}
                                onChange={(event: any) => handleEstimateChange(event, "estimatedDays")}
                                error={Boolean(formikTask.errors?.estimatedDays && formikTask.touched?.estimatedDays)}
                            />
                            <Typography >
                                {t("estimation_page.days")}
                            </Typography>
                        </Stack>*/}

                        {isModifiable && taskType.active &&
                            <>
                                <Chip
                                    icon={<SaveIcon fontSize="small" />}
                                    label={t("estimation_page.save")}
                                    variant="outlined"
                                    color='success'
                                    disabled={ !edited || formikTask.isSubmitting || !formikTask.isValid }
                                    onClick={formikTask.submitForm}
                                />

                                <Chip
                                    icon={<DeleteIcon fontSize="small" />}
                                    label={t("delete")}
                                    variant="outlined"
                                    color='redExtra'
                                    disabled={formikTask.isSubmitting}
                                    onClick={deleteTask}
                                />
                            </>
                        }

                        {!taskType.active && activePhaseType &&
                            <Chip
                                icon={<CheckIcon fontSize="small" />}
                                label={t("project_page.activate_task")}
                                variant="outlined"
                                color='success'
                                onClick={activateTask}
                            />
                        }
                    </Stack>
                </Grid>
            </Grid>
        </Paper>
    );
}

function CollapsiblePhase({ t, phaseType, phaseService, fillElementTypes, isModifiable, activeElementType }: any) {
    const [openTasks, setOpenTasks] = React.useState(false);
    const [edited, setEdited] = React.useState(false);
    const [showNewTask, setShowNewTask] = React.useState(false);
    const taskTypeService = React.useMemo(() => new TaskTypeService(), []);

    /*const phaseMinDuration: number = phaseType.taskTypes.reduce(
        (acc: number, task: any) => acc < task.estimatedDays ? task.estimatedDays : acc,
        0
    );*/

    React.useEffect(() => {
        formikPhase.setValues(
            {
                name: phaseType.name,
                estimatedDays: phaseType.estimatedDays
            }
        );
        setEdited(false);
    }, [phaseType]);

    const validate = (values: FormType) => {
        let errors: any = {};
        if (!values.name) {
            errors.name = "Required";
        }
        return errors;
    }

    const handleSubmitNewTask = (values: any) => {
        let taskAux = {
            name: values.name,
            phase: {
                idPhase: phaseType.idPhase
            }
        }
        // @ts-ignore
        taskTypeService.create(taskAux).then(({data : response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                //addMessage("danger", response.message);
                toast.error(response.message);
                formikNewTask.setSubmitting(false);
            } else {
                //addMessage("success", t("project_page.msg_success_task_add"));
                toast.success(t("project_page.msg_success_task_add"));
                setShowNewTask(false);
                formikNewTask.resetForm();
            }
            fillElementTypes();
        });
    }

    const formikNewTask = useFormik({
        initialValues: {
            name: ''
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitNewTask(values);
        }
    });

    const handleSubmitPhase = (values: any) => {
        let phaseAux = {
            name: values.name,
            //estimatedDays: values.estimatedDays
        }
        // @ts-ignore
        phaseService.update(phaseType.idPhase, phaseAux).then(({data : response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                //addMessage("danger", response.message);
                toast.error(response.message);
            } else {
                //addMessage("success", t("project_page.msg_success_phase_update"));
                toast.success(t("project_page.msg_success_phase_update"));
                //formikPhase.resetForm();
            }
            setEdited(false);
            formikPhase.setSubmitting(false);
            fillElementTypes();
        });
    }

    const formikPhase = useFormik({
        initialValues: {
            name: phaseType.name,
            //estimatedDays: phaseType.estimatedDays
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitPhase(values);
        }
    });

    const activatePhase = () => {
        // @ts-ignore
        phaseService.activate(phaseType.idPhase).then(({data: response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.phase_activated"));
            }

            setEdited(false);
            formikPhase.setSubmitting(false);
            fillElementTypes();
        });
    }

    const deletePhase = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <TrueffortConfirmAlert
                        title={
                            <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("project_page.msg_delete_phase_confirm1")}
                            </Typography>
                        }
                        alertColor='error'
                        message={t("project_page.msg_delete_phase_confirm2") + "" + phaseType.name + "?"}
                        buttons={[
                            {
                                label: t("cancel"),
                                onClick: () => onClose()
                            },
                            {
                                label: t("accept"),
                                onClick: () => {
                                    try {
                                        // @ts-ignore
                                        phaseService.delete(phaseType.idPhase).then(({data : response}) => {
                                            if (response.success) {
                                                toast.success(t("project_page." + response.data));
                                                fillElementTypes();
                                            } else {
                                                toast.error("La fase no pudo ser eliminada");
                                            }
                                        }).catch(function (error: any) {
                                            toast.error("Ocurrió un error al eliminar la fase.");
                                        });
                                    } catch (error) {
                                        console.log("Error #Users handleDelete" + JSON.stringify(error));
                                        toast.error("Ocurrió un error al eliminar la fase.");
                                    }

                                    onClose();
                                }
                            }
                        ]}
                    />
                )
            }
        });
    }

    /*const newEditingValues = (values: FormType) => {
        const campos: (keyof FormType)[] = Object.keys(values) as Array<keyof FormType>;
        for (let i = 0; i < campos.length; i++) {
            if (phaseType[campos[i]] !== values[campos[i]]) {
                return true;
            }
        }

        return false
    }*/

    const handleNameChange = (e: any) => {
        formikPhase.handleChange(e);

        /*if (!edited && newEditingValues({estimatedDays: formikPhase.values.estimatedDays, name: e.target.value})) {
            setEdited(true);
        } else if (edited && !newEditingValues({estimatedDays: formikPhase.values.estimatedDays, name: e.target.value})) {
            setEdited(false);
        }*/

        if (!edited && phaseType.name !== e.target.value) {
            setEdited(true);
        } else if (edited && phaseType.name === e.target.value) {
            setEdited(false);
        }
    }

    /*const handleDurationBlur = (e: any) => {
        formikPhase.handleBlur(e);
        if (!isNaN(Number(e.target.value)) && Number(e.target.value) < phaseMinDuration) {
            formikPhase.setFieldValue("estimatedDays", phaseType.estimatedDays);
            setEdited(false);
        }
    }

    const handleDurationChange = (e: any) => {
        let newEstimate: number = 0;

        if (!isNaN(Number(e.target.value)) && !Number.isInteger(Number(e.target.value))) {
            newEstimate = Math.ceil(e.target.value);
            formikPhase.setFieldValue("estimatedDays", newEstimate);
        } else {
            formikPhase.handleChange(e);
            newEstimate = e.target.value;
        }

        const campos = { name: formikPhase.values.name, estimatedDays: Number(newEstimate) };

        if (!edited && newEditingValues(campos) && e.target.value !== "") {
            setEdited(true);
        } else if (edited && !newEditingValues(campos)) {
            setEdited(false);
        }
    }*/

    return (
        <>
            <Paper
                component="form"
                onSubmit={formikPhase.handleSubmit}
                variant="outlined"
                square sx={{ padding: '10px', backgroundColor: 'rgba(215, 235, 240, 0.30)' }}
            >
                <Grid container spacing={1} >
                    <Grid item xs={.5} ></Grid>
                    <Grid item xs={10.5}  >
                        <Stack direction="row" spacing={2} alignItems="center" >
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpenTasks(!openTasks)}
                            >
                                {openTasks ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                            </IconButton>

                            <TrueffortTextField
                                id={"phase-name"}
                                name="name"
                                size="small"
                                required
                                disabled={!isModifiable || !phaseType.active}
                                value={formikPhase.values.name}
                                onBlur={formikPhase.handleBlur}
                                onChange={handleNameChange}
                                error={Boolean(formikPhase.errors?.name && formikPhase.touched?.name)}
                                //helperText={!formikPhase.errors?.name || !formikPhase.touched?.name ? undefined : t(formikPhase.errors.name)}
                            />

                            <Chip
                                sx={{ borderRadius: '3px' }}
                                icon={<FontAwesomeIcon icon={faFolderTree} color={'#9A64E2'} />}
                                label={phaseType.taskTypes.length + " " + t("home.tasks")}
                                variant='outlined'
                            />

                            {/*<Stack direction="row" spacing={1} alignItems="center">
                                <Typography >
                                    {t("estimation_page.effort") + ": " + phaseType.estimatedTime + " " + t("estimation_page.man_hours")}
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography >
                                    {t("project_tasks_page.duration")}:
                                </Typography>
                                <TextField
                                    name="estimatedDays"
                                    sx={{ width: '89px' }}
                                    type="number"
                                    InputProps={{ inputProps: { min: phaseMinDuration, style: { background:'#F5F5F5' } } }}
                                    size="small"
                                    disabled={!isModifiable || !phaseType.active}
                                    onBlur={handleDurationBlur}
                                    value={formikPhase.values.estimatedDays}
                                    onChange={(event: any) => handleDurationChange(event)}
                                    //error={Boolean(formikTask.errors?.estimatedDays && formikTask.touched?.estimatedDays)}
                                />
                                <Typography >
                                    {t("estimation_page.days")}
                                </Typography>
                            </Stack>*/}

                            {isModifiable && phaseType.active &&
                                <>
                                    <Chip
                                        icon={<SaveIcon fontSize="small" />}
                                        label={t("estimation_page.save")}
                                        variant="outlined"
                                        color='success'
                                        disabled={!edited || formikPhase.isSubmitting}
                                        onClick={formikPhase.submitForm}
                                    />

                                    <Chip
                                        icon={<DeleteIcon fontSize="small" />}
                                        label={t("delete")}
                                        variant="outlined"
                                        color='redExtra'
                                        disabled={formikPhase.isSubmitting}
                                        onClick={deletePhase}
                                    />
                                </>
                            }

                            {!phaseType.active && activeElementType &&
                                <Chip
                                    icon={<CheckIcon fontSize="small" />}
                                    label={t("project_page.activate_phase")}
                                    variant="outlined"
                                    color='success'
                                    onClick={activatePhase}
                                />
                            }
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>

            <Collapse in={openTasks} timeout="auto" unmountOnExit >
                <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#F2E9FF' }} >
                    <Grid container spacing={1} >
                        <Grid item xs={1} ></Grid>
                        <Grid item xs={11} >
                            <Typography sx={{ display: 'flex', alignItems: "center" }} >
                                <AssignmentIcon fontSize="small" sx={{ color: '#553D74', marginRight: '6px' }} />
                                {t("home.tasks")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {phaseType.taskTypes.map((taskType: any) =>
                    <CollapsibleTask
                        key={taskType.idTaskType.toString()}
                        t={t}
                        taskType={taskType}
                        idPhaseType={phaseType.idPhase}
                        taskTypeService={taskTypeService}
                        fillElementTypes={fillElementTypes}
                        isModifiable={isModifiable}
                        activePhaseType={phaseType.active}
                    />
                )}

                <Paper
                    component="form"
                    onSubmit={formikNewTask.handleSubmit}
                    variant="outlined"
                    square
                    sx={{ padding: '10px', backgroundColor: 'rgba(242, 233, 255, 0.30)' }}
                >
                    <Grid container spacing={1} >
                        <Grid item xs={1} ></Grid>
                        <Grid item xs={11}  >
                            <Stack direction="row" spacing={2} alignItems="center" >
                                {showNewTask ?
                                    <>
                                        <TrueffortTextField
                                            name="name"
                                            size="small"
                                            required
                                            placeholder={t("project_page.new_task") + "..."}
                                            disabled={phaseType.isSubmitting}
                                            onBlur={formikNewTask.handleBlur}
                                            onChange={formikNewTask.handleChange}
                                            error={Boolean(formikNewTask.errors?.name && formikNewTask.touched?.name)}
                                            //helperText={!formikNewTask.errors?.name || !formikNewTask.touched?.name ? " ": t(formikNewTask.errors.name)}
                                        />

                                        <Chip
                                            icon={<AddIcon fontSize="small" />}
                                            label={t("project_page.save_new_task_type")}
                                            variant="outlined"
                                            color="success"
                                            onClick={formikNewTask.submitForm}
                                        />

                                        <Chip
                                            icon={<CancelIcon fontSize="small" />}
                                            label={t("Cancel")}
                                            variant="outlined"
                                            color='redExtra'
                                            onClick={() => setShowNewTask(false)}
                                        />
                                    </> :

                                    <TrueffortChip
                                        icon={<AddIcon fontSize="small" />}
                                        label={t("project_page.add_task")}
                                        variant="outlined"
                                        color="purple"
                                        disabled={!phaseType.active}
                                        onClick={() => setShowNewTask(true)}
                                    />
                                }
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            </Collapse>
        </>
    );
}



function CollapsibleElement({ t, elementType, index, fillElementTypes, elementTypeService, isModifiable }: any) {
    const [openPhases, setOpenPhases] = React.useState(false);
    const [edited, setEdited] = React.useState(false);
    const [showNewPhase, setShowNewPhase] = React.useState(false);
    const phaseService = React.useMemo(() => new PhaseService(), []);

    /*const elementMinDuration: number = elementType.phaseTypes.reduce(
        (acc: number, phase: any) => acc < phase.estimatedDays ? phase.estimatedDays : acc,
        0
    );*/

    React.useEffect(() => {
        formikElementType.setValues(
            {
                name: elementType.name,
                estimatedDays: elementType.estimatedDays
            }
        );
        setEdited(false);
    }, [elementType]);

    const validate = (values: FormType) => {
        let errors: any = {};
        if (!values.name) {
            errors.name = "Required";
        }
        return errors;
    }

    const handleSubmitNewPhase = (values: any) => {
        let phaseAux = {
            name: values.name,
            elementType: {
                idElementType: elementType.idElementType
            }
        }

        // @ts-ignore
        phaseService.create(phaseAux).then(({data : response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.msg_success_phase_add"));
                setShowNewPhase(false);
                formikNewPhase.resetForm();
            }
            formikNewPhase.setSubmitting(false);
            fillElementTypes();
        });

    }

    const formikNewPhase = useFormik({
        initialValues: {
            name: ''
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitNewPhase(values);
        }
    });

    const formikElementType = useFormik({
        initialValues: {
            name: elementType.name,
            //estimatedDays: elementType.estimatedDays
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitElementType(values);
        }
    });

    const handleSubmitElementType = (values: any) => {
        let newElementType = {
            name: values.name,
            //estimatedDays: values.estimatedDays,
            projectType: {
                idProjectType: elementType.projectType.idProjectType
            }
        }

        elementTypeService.update(elementType.idElementType, newElementType).then(({data: response} : any) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.msg_success_element_type_update"));
                fillElementTypes();
            }
            setEdited(false);
            formikElementType.setSubmitting(false);
        });
    }

    const confirmDeleteElementType = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <TrueffortConfirmAlert
                        title={
                            <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("project_page.msg_delete_pe_confirm1")}
                            </Typography>
                        }
                        alertColor='error'
                        message={t("project_page.msg_delete_pe_confirm2") + "" + elementType.name + "?"}
                        buttons={[
                            {
                                label: t("cancel"),
                                onClick: () => onClose()
                            },
                            {
                                label: t("accept"),
                                onClick: () => {
                                    try {
                                        // @ts-ignore
                                        elementTypeService.delete(elementType.idElementType).then(({data : response}) => {
                                            if (response.success) {
                                                toast.success(t("project_page." + response.data));
                                                fillElementTypes();
                                            } else {
                                                toast.error("EL elemento no se pudo eliminar")
                                            }
                                        }).catch(function (error: any) {
                                            toast.error("Ocurrió un error al eliminar el elemento.");
                                        });
                                    } catch (error) {
                                        console.log("Error #Users handleDelete" + JSON.stringify(error));
                                        toast.error("Ocurrió un error al eliminar el elemento.");
                                    }

                                    onClose();
                                }
                            }
                        ]}
                    />
                );
            }
        });
    }

    const activateElementType = () => {
        elementTypeService.reactivate(elementType.idElementType).then(({data: response} : any) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.msg_success_element_type_update"));
                fillElementTypes();
            }
        });
    }

    /*const newEditingValues = (values: FormType) => {
        const campos: (keyof FormType)[] = Object.keys(values) as Array<keyof FormType>;
        for (let i = 0; i < campos.length; i++) {
            if (elementType[campos[i]] !== values[campos[i]]) {
                return true;
            }
        }

        return false
    }*/

    const handleNameChange = (e: any) => {
        formikElementType.handleChange(e);

        /*if (!edited && newEditingValues({estimatedDays: formikElementType.values.estimatedDays, name: e.target.value})) {
            setEdited(true);
        } else if (edited && !newEditingValues({estimatedDays: formikElementType.values.estimatedDays, name: e.target.value})) {
            setEdited(false);
        }*/

        if (!edited && elementType.name !== e.target.value) {
            setEdited(true);
        } else if (edited && elementType.name === e.target.value) {
            setEdited(false);
        }

    }

    /*const handleDurationBlur = (e: any) => {
        formikElementType.handleBlur(e);
        if (!Number.isNaN(Number(e.target.value)) && Number(e.target.value) < elementMinDuration) {
            formikElementType.setFieldValue("estimatedDays", elementType.estimatedDays);
            setEdited(false);
        }
    }

    const handleDurationChange = (e: any) => {
        let newEstimate: number= 0;

        if (!isNaN(Number(e.target.value)) && !Number.isInteger(Number(e.target.value))) {
            newEstimate = Math.ceil(e.target.value);
            formikElementType.setFieldValue("estimatedDays", newEstimate);
        } else {
            formikElementType.handleChange(e);
            newEstimate = e.target.value;
        }

        const campos = { name: formikElementType.values.name, estimatedDays: Number(newEstimate) };

        if (!edited && newEditingValues(campos) && e.target.value !== "") {
            setEdited(true);
        } else if (edited && !newEditingValues(campos)) {
            setEdited(false);
        }
    }*/

    return (
        <>
            <Paper variant="outlined" square sx={{ padding: '10px' }} >
                <Grid container spacing={1} >
                    <Grid item xs={0.5} sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }} >
                        <Typography color='#6A6A6A' >
                            {index + 1}
                        </Typography>
                    </Grid>
                    <Grid item xs={10.5} >
                        <Stack direction="row" spacing={2} alignItems="center" >
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpenPhases(!openPhases)}
                            >
                                {openPhases ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
                            </IconButton>

                            <TrueffortTextField
                                id={"element-name-" + index}
                                name="name"
                                size="small"
                                required
                                disabled={!isModifiable || !elementType.active}
                                value={formikElementType.values.name}
                                onBlur={formikElementType.handleBlur}
                                onChange={handleNameChange}
                                error={Boolean(formikElementType.errors?.name && formikElementType.touched?.name)}
                                //helperText={!formikPhase.errors?.name || !formikPhase.touched?.name ? undefined : t(formikPhase.errors.name)}
                            />

                            <Chip
                                sx={{ borderRadius: '3px' }}
                                icon={<FontAwesomeIcon icon={faFolderTree} color={'#68C8BA'} />}
                                label={elementType.phaseTypes.length + " " + t("home.phases")}
                                variant='outlined'
                            />

                            {/*<Stack direction="row" spacing={1} alignItems="center">
                                <Typography >
                                    {t("estimation_page.effort") + ": " + elementType.estimatedTime + " " + t("estimation_page.man_hours")}
                                </Typography>
                            </Stack>

                            <Stack direction="row" spacing={1} alignItems="center">
                                <Typography >
                                    {t("project_tasks_page.duration")}:
                                </Typography>
                                <TextField
                                    name="estimatedDays"
                                    sx={{ width: '89px' }}
                                    type="number"
                                    InputProps={{ inputProps: { min: elementMinDuration, style: { background:'#F5F5F5' } } }}
                                    size="small"
                                    disabled={!isModifiable || !elementType.active}
                                    onBlur={handleDurationBlur}
                                    value={formikElementType.values.estimatedDays}
                                    onChange={(event: any) => handleDurationChange(event)}
                                    //error={Boolean(formikTask.errors?.estimatedDays && formikTask.touched?.estimatedDays)}
                                />
                                <Typography >
                                    {t("estimation_page.days")}
                                </Typography>
                            </Stack>*/}

                            {isModifiable && elementType.active &&
                                <>
                                    <Chip
                                        icon={<SaveIcon fontSize="small" />}
                                        label={t("estimation_page.save")}
                                        variant="outlined"
                                        color='success'
                                        disabled={!edited || formikElementType.isSubmitting}
                                        onClick={formikElementType.submitForm}
                                    />

                                    <Chip
                                        icon={<DeleteIcon fontSize="small" />}
                                        label={t("delete")}
                                        variant="outlined"
                                        color='redExtra'
                                        disabled={formikElementType.isSubmitting}
                                        onClick={confirmDeleteElementType}
                                    />
                                </>
                            }

                            {!elementType.active &&
                                <Chip
                                    icon={<CheckIcon fontSize="small" />}
                                    label={t("project_page.activate_phase")}
                                    variant="outlined"
                                    color='success'
                                    onClick={activateElementType}
                                />
                            }
                        </Stack>
                    </Grid>
                </Grid>
            </Paper>

            <Collapse in={openPhases} timeout="auto" unmountOnExit >
                <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#D7EBF0' }} >
                    <Grid container spacing={1} >
                        <Grid item xs={0.5} ></Grid>
                        <Grid item xs={10.5} >
                            <Typography color={'#27535E'} sx={{ display: 'flex', alignItems: "center" }} >
                                <SvgIcon fontSize="small" sx={{ marginRight: '6px' }} >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11" fill="none">
                                        <g clipPath="url(#clip0_578_12469)">
                                            <path d="M8.93752 7.79167C8.87794 7.79167 8.81835 7.79167 8.75877 7.81L8.02085 6.32042C8.18413 6.16122 8.2962 5.95692 8.3427 5.73367C8.38921 5.51041 8.36804 5.27836 8.2819 5.06721C8.19577 4.85605 8.04859 4.67541 7.8592 4.54838C7.6698 4.42136 7.44682 4.35373 7.21877 4.35417C7.15919 4.35417 7.10419 4.35417 7.04002 4.3725L6.29294 2.88292C6.51294 2.67667 6.64585 2.38792 6.64585 2.0625C6.64585 1.75861 6.52513 1.46716 6.31025 1.25227C6.09536 1.03739 5.80391 0.916667 5.50002 0.916667C5.19613 0.916667 4.90468 1.03739 4.68979 1.25227C4.47491 1.46716 4.35419 1.75861 4.35419 2.0625C4.35419 2.38792 4.4871 2.67667 4.70252 2.88292L3.96002 4.3725C3.89585 4.35417 3.84085 4.35417 3.78127 4.35417C3.55323 4.35373 3.33024 4.42136 3.14084 4.54838C2.95145 4.67541 2.80427 4.85605 2.71814 5.06721C2.632 5.27836 2.61083 5.51041 2.65734 5.73367C2.70384 5.95692 2.81591 6.16122 2.97919 6.32042L2.24127 7.81C2.18169 7.79167 2.1221 7.79167 2.06252 7.79167C1.75863 7.79167 1.46718 7.91239 1.25229 8.12727C1.03741 8.34216 0.916687 8.63361 0.916687 8.9375C0.916687 9.24139 1.03741 9.53284 1.25229 9.74773C1.46718 9.96261 1.75863 10.0833 2.06252 10.0833C2.21299 10.0833 2.36199 10.0537 2.50101 9.99611C2.64003 9.93853 2.76635 9.85413 2.87275 9.74773C2.97915 9.64133 3.06355 9.51501 3.12113 9.37599C3.17872 9.23697 3.20835 9.08797 3.20835 8.9375C3.20835 8.61667 3.07544 8.32333 2.86002 8.11708L3.60252 6.6275C3.66669 6.64583 3.72169 6.64583 3.78127 6.64583C3.84085 6.64583 3.89585 6.64583 3.96002 6.6275L4.7071 8.11708C4.49169 8.32333 4.35419 8.61667 4.35419 8.9375C4.35419 9.24139 4.47491 9.53284 4.68979 9.74773C4.90468 9.96261 5.19613 10.0833 5.50002 10.0833C5.80391 10.0833 6.09536 9.96261 6.31025 9.74773C6.52513 9.53284 6.64585 9.24139 6.64585 8.9375C6.64585 8.63361 6.52513 8.34216 6.31025 8.12727C6.09536 7.91239 5.80391 7.79167 5.50002 7.79167C5.44044 7.79167 5.38085 7.79167 5.32127 7.81L4.58335 6.32042C4.79419 6.11417 4.9271 5.82542 4.9271 5.5C4.9271 5.17458 4.79419 4.88583 4.58335 4.67958L5.32127 3.19C5.38085 3.20833 5.44044 3.20833 5.50002 3.20833C5.5596 3.20833 5.61919 3.20833 5.67877 3.19L6.41669 4.67958C6.21044 4.88583 6.07294 5.17917 6.07294 5.5C6.07294 5.80389 6.19366 6.09534 6.40854 6.31023C6.62343 6.52511 6.91488 6.64583 7.21877 6.64583C7.27835 6.64583 7.33335 6.64583 7.39752 6.6275L8.1446 8.11708C7.92919 8.32333 7.79169 8.61667 7.79169 8.9375C7.79169 9.24139 7.91241 9.53284 8.12729 9.74773C8.34218 9.96261 8.63363 10.0833 8.93752 10.0833C9.24141 10.0833 9.53286 9.96261 9.74775 9.74773C9.96263 9.53284 10.0834 9.24139 10.0834 8.9375C10.0834 8.63361 9.96263 8.34216 9.74775 8.12727C9.53286 7.91239 9.24141 7.79167 8.93752 7.79167Z" fill="#27535E"/>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_578_12469">
                                                <rect width="11" height="11" fill="white"/>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </SvgIcon>

                                {t("home.phases")}
                            </Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {elementType.phaseTypes.map((phaseType: any) =>
                    <CollapsiblePhase
                        key={phaseType.idPhase.toString()}
                        t={t}
                        phaseType={phaseType}
                        phaseService={phaseService}
                        fillElementTypes={fillElementTypes}
                        isModifiable={isModifiable}
                        activeElementType={elementType.active}
                    />
                )}

                <Paper
                    component="form"
                    onSubmit={formikNewPhase.handleSubmit}
                    variant="outlined"
                    square
                    sx={{ padding: '10px', backgroundColor: 'rgba(215, 235, 240, 0.30)' }}
                >
                    <Grid container spacing={1} >
                        <Grid item xs={.5} ></Grid>
                        <Grid item xs={10.5}  >
                            <Stack direction="row" spacing={2} alignItems="center" >
                                {showNewPhase ?
                                    <>
                                        <IconButton
                                            aria-label="expand row"
                                            size="small"
                                            disabled
                                        >
                                            <ArrowRightIcon />
                                        </IconButton>

                                        <TrueffortTextField
                                            name="name"
                                            size="small"
                                            required
                                            placeholder={t("project_page.new_phase") + "..."}
                                            disabled={formikNewPhase.isSubmitting}
                                            onBlur={formikNewPhase.handleBlur}
                                            onChange={formikNewPhase.handleChange}
                                            error={Boolean(formikNewPhase.errors?.name && formikNewPhase.touched?.name)}
                                        />

                                        <Chip
                                            sx={{ borderRadius: '3px' }}
                                            icon={<FontAwesomeIcon icon={faFolderTree} color={'#9A64E2'} />}
                                            label={"0 " + t("home.tasks")}
                                            variant='outlined'
                                        />

                                        <Chip
                                            icon={<AddIcon fontSize="small" />}
                                            label={t("project_page.save_new_phase_type")}
                                            variant="outlined"
                                            color="success"
                                            onClick={formikNewPhase.submitForm}
                                        />

                                        <Chip
                                            icon={<CancelIcon fontSize="small" />}
                                            label={t("Cancel")}
                                            variant="outlined"
                                            color='redExtra'
                                            onClick={() => setShowNewPhase(false)}
                                        />
                                    </> :

                                    <TrueffortChip
                                        icon={<AddIcon fontSize="small" />}
                                        label={t("project_page.add_phase")}
                                        variant="outlined"
                                        color="darkT"
                                        disabled={!elementType.active}
                                        onClick={() => setShowNewPhase(true)}
                                    />
                                }
                            </Stack>
                        </Grid>
                    </Grid>
                </Paper>
            </Collapse>
        </>
    );
}

// @ts-ignore
const ProjectTypesPage = () => {
    const {user} = useAuthContext() as { user : User };
    const {t} = useTranslation();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [projectTypes, setProjectTypes] = React.useState([]);
    const [idSelectedProjectType, setIdSelectedProjectType] = React.useState("");
    const [selectedProjectType, setSelectedProjectType] = React.useState({});
    const [idSelectedElementType, setIdSelectedElementType] = React.useState("");
    const [selectedElementType, setSelectedElementType] = React.useState({});
    const [elementTypes, setElementTypes] = React.useState([]);
    const [showNewLayout, setShowNewLayout] = React.useState(false);
    const [creatingEmptyLayout, setCreatingEmptyLayout] = React.useState(false);
    const [isEditingProjectTypeName, setIsEditingProjectTypeName] = React.useState(false);
    const [showNewElementType, setShowNewElementType] = React.useState(false);
    const [isEditingElementTypeName, setIsEditingElementTypeName] = React.useState(false);

    const projectTypeService = React.useMemo(() => new ProjectTypeService(), []);
    const elementTypeService = React.useMemo(() => new ElementTypeService(), []);

    React.useEffect(() => {
        fillProjectTypes();
    }, []);
    
    React.useEffect(() => {
        fillElementTypes();
    }, [idSelectedProjectType]);

    React.useEffect(() => {
        handleChangeProjectTypeSelect(idSelectedProjectType);
    }, [projectTypes]);

    const fillProjectTypes = () => {
        // @ts-ignore
        projectTypeService.getAll().then(({data: response}) => {
            if (Array.isArray(response.data)) {
              if (user.instance.idInstance != ID_INSTANCE_SPINGERE) {
                setProjectTypes(response.data.filter((p:any) => p.name != user.baseTemplateName));
              } else {
                setProjectTypes(response.data);
              }
            }
        });
    }

    const fillElementTypes = () => {
        //console.log("idSelectedProjectType: " + idSelectedProjectType);
        // @ts-ignore
        if (idSelectedProjectType === "") {
            setElementTypes([]);
            return;
        }
        elementTypeService.getAllByProjectType(idSelectedProjectType).then(({data: response} : any) => {
            if (Array.isArray(response.data)) {
                setElementTypes(response.data);
            }
        });

        // Consultar si el proyecto tiene elementos sin actividades
        projectTypeService.hasElementsWithoutActivities(idSelectedProjectType).then(({data: response} : any) => {
            console.log("RE", response);
            if (typeof response.data != "undefined") {
                if (response.data === true) {
                    toast.warning(t("project_page.msg_layout_incomplete"));
                }
            }
        });
    }

    const validate = (values: FormType) => {
        let errors: any = {};
        if (!values.name) {
            errors.name = "Required";
        }
        return errors;
    }

    const formikProjectType = useFormik({
        initialValues: {
            name: ''
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitProjectType(values);
        }
    });

    const handleSubmitProjectType = (values: any) => {
        if (!isEditingProjectTypeName) {
            let projectTypeAux = {
                idProjectType: idSelectedProjectType,
                name: values.name
            }

            // @ts-ignore
            projectTypeService.createFromLayout(projectTypeAux).then(({data: response}) => {
                if (response.internalError != null && response.internalError && response.message != null) {
                    toast.error(response.message);
                    setShowNewLayout(false);
                    setCreatingEmptyLayout(false);
                    formikProjectType.resetForm();
                } else {
                    toast.success(t("project_page.msg_success_project_type_add"));
                    setShowNewLayout(false);
                    setCreatingEmptyLayout(false);
                    setIdSelectedProjectType(typeof response.data.idProjectType != "undefined" ? response.data.idProjectType : response.data.projectType?.idProjectType);
                    setIdSelectedElementType(response.data.idElementType);
                    formikProjectType.resetForm();
                }
                fillProjectTypes();
            });
        } else {    // MODIFICAR NOMBRE DEL TIPO DE PROYECTO
            let projectTypeAux = {
                name: values.name
            }
            // @ts-ignore
            projectTypeService.update(idSelectedProjectType, projectTypeAux).then(({data : response}) => {
                if (response.internalError != null && response.internalError && response.message != null) {
                    toast.error(response.message);
                } else {
                    toast.success(t("project_page.msg_success_project_type_update"));
                    setShowNewLayout(false);
                    setCreatingEmptyLayout(false);
                    setIsEditingProjectTypeName(false);
                    setIdSelectedProjectType(response.data.idProjectType);
                    formikProjectType.resetForm();
                    fillProjectTypes();
                }
            });
        }
    }

    const handleChangeProjectTypeSelect = (id: string) => {
        setIdSelectedProjectType(id);
        setIsEditingProjectTypeName(false);
        setIdSelectedElementType("");
        /*setSelectedProjectType(
            projectTypes.find((pT: any) => pT.idElementType == id)
        );*/
        projectTypes.map((p: any, i: number) => {
            if (p.idProjectType == id) {
                setSelectedProjectType(p);
            }
        });
    }

    const handleChangeElementType = (id: number) => {
        setIdSelectedElementType(id);
        elementTypes.map((e: any, i: number) => {
            if (e.idElementType == id) {
                setSelectedElementType(e);
            }
        });
    }

    const formikNewElementType = useFormik({
        initialValues: {
            name: ''
        },
        validate: validate,
        onSubmit: (values, {setSubmitting, setValues}) => {
            handleSubmitElementType(values);
        }
    });

    const handleSubmitElementType = (values: any) => {
        let newElementType = {
            name: formikNewElementType.values.name,
            projectType: {
                idProjectType: idSelectedProjectType
            }
        }

        // @ts-ignore
        elementTypeService.create(newElementType).then(({data: response}) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                console.log(response);
                toast.error(response.message);
            } else {
                toast.success(t("project_page.msg_success_element_type_ass"));
                setShowNewElementType(false);
                fillElementTypes();
                setIdSelectedElementType(response.data.idElementType);
                formikNewElementType.resetForm();
            }

            formikNewElementType.setSubmitting(false);
        });
    }

    const confirmDeleteProjectType = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return(
                    <TrueffortConfirmAlert
                        title={
                            <Typography color='error' variant='h6' fontWeight={700} marginBottom='20px' >
                                <ReportProblemIcon color='error' />&nbsp;&nbsp;{t("project_page.msg_delete_confirm1")}
                            </Typography>
                        }
                        alertColor='error'
                        message={t("project_page.msg_delete_confirm2") + "" + selectedProjectType.name + "?"}
                        buttons={[
                            {
                                label: t("cancel"),
                                onClick: () => onClose()
                            },
                            {
                                label: t("accept"),
                                onClick: () => {
                                    try {
                                        // @ts-ignore
                                        projectTypeService.delete(idSelectedProjectType).then(({data: response}) => {
                                            console.log(response.data);

                                            if (response.success) {
                                                toast.success(t("project_page." + response.data));
                                                fillProjectTypes();
                                                setIdSelectedProjectType("");
                                                setSelectedProjectType({});
                                            } else {
                                                toast.error("La plantilla no puso ser eliminada");
                                            }
                                        }).catch(function (error: any) {
                                            toast.error("Ocurrió un error al eliminar la plantilla.");
                                        });
                                    } catch (error) {
                                        console.log("Error #Users handleDelete" + JSON.stringify(error));
                                        toast.error("Ocurrió un error al eliminar la plantilla.");
                                    }

                                    onClose();
                                }
                            }
                            ]}
                    />
                );
            }
        });
    }

    const reactivateProjectType = () => {
        projectTypeService.reactivate(idSelectedProjectType).then(({data: response} : any) => {
            if (response.internalError != null && response.internalError && response.message != null) {
                toast.error(response.message);
            } else {
                toast.success(t("project_page.msg_success_project_type_update"));
                setShowNewElementType(false);
                fillProjectTypes();
                setIdSelectedElementType("");
                setIsEditingElementTypeName(false);
                //formikElementType.resetForm();
            }
        });
    }

    return (
        <SiteWrapper >
            <Container maxWidth='xl' sx={{ marginTop: '20px' }} >
                <Typography variant='caption' color='#4A4A4A' >
                    {t("project_page.element_types")}
                </Typography>
                <Typography color='#4A4A4A' variant="h4" >
                    {t("project_page.templates")}
                </Typography>
                <Typography variant='caption' color='#4A4A4A' >
                    {t("project_page.message_project_types")}
                </Typography>
            </Container>

            <Container maxWidth='xl' sx={{ marginTop: '20px' }} >
                <Paper
                    //component="form"
                    //onSubmit={formikProjectType.handleSubmit}
                    elevation={0}
                    square
                    sx={{ padding: '6px', bgcolor: '#F5F5F5' }}
                >
                    <Card elevation={2} >
                        <CardContent>
                            <Grid container spacing={2}  >
                                <Grid item xs={12} md={12} sx={{display: 'flex', alignItems: "flex-end", justifyContent: 'space-between'}} >
                                    <Typography variant="h5" color='#050536' >
                                        {t("project_page.define_template")}
                                    </Typography>
                                    {matches ?
                                        <TrueffortChip
                                            id="new-template-button"
                                            variant="filled"
                                            label={<AddIcon />}
                                            color="primary"
                                            disabled={isEditingProjectTypeName || showNewLayout}
                                            onClick={() => {
                                                setCreatingEmptyLayout(true);
                                                setIdSelectedProjectType("");
                                                setSelectedProjectType({});
                                            }}
                                        /> :

                                        <TrueffortButton
                                            id="new-template-button"
                                            size="small"
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            disabled={isEditingProjectTypeName || showNewLayout}
                                            onClick={() => {
                                                setCreatingEmptyLayout(true);
                                                setIdSelectedProjectType("");
                                                setSelectedProjectType({});
                                            }}
                                        >
                                            {t("project_page.new_template")}
                                        </TrueffortButton>
                                    }
                                </Grid>

                                {(creatingEmptyLayout || showNewLayout) &&
                                    <>
                                        <Grid item xs={12} md={9} >
                                            <TrueffortTextField
                                                id="new-project-type-name-input"
                                                name="name"
                                                size="small"
                                                fullWidth
                                                placeholder={t("project_page.new_project_type_name_placeholder") + "..."}
                                                value={formikProjectType.values.name}
                                                onBlur={formikProjectType.handleBlur}
                                                onChange={formikProjectType.handleChange}
                                                error={Boolean(formikProjectType.errors?.name && formikProjectType.touched?.name)}
                                                //helperText={!formikProjectType.errors?.name || !formikProjectType.touched?.name ? undefined : t(formikProjectType.errors.name)}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3} >
                                            <Stack direction="row" spacing={2} alignItems="flex-end" justifyContent={matches ? "center" : "flex-end"} >
                                                <TrueffortButton
                                                    id="save-new-project-button"
                                                    size="small"
                                                    //type="submit"
                                                    variant="contained"
                                                    color="indigo"
                                                    startIcon={<EditIcon />}
                                                    onClick={formikProjectType.submitForm}
                                                >
                                                    {t("estimation_page.save")}
                                                </TrueffortButton>

                                                <TrueffortButton
                                                    id="cancel-new-project-button"
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    startIcon={<RemoveIcon />}
                                                    onClick={() => {
                                                        formikProjectType.resetForm();
                                                        creatingEmptyLayout && setCreatingEmptyLayout(false);
                                                        showNewLayout && setShowNewLayout(false);

                                                    }}
                                                >
                                                    {t("Cancel")}
                                                </TrueffortButton>
                                            </Stack>
                                        </Grid>
                                    </>
                                }

                                <Grid item xs={12} md={8} >
                                    {isEditingProjectTypeName ?
                                        <TrueffortTextField
                                            id="change-project-name-input"
                                            name="name"
                                            size="small"
                                            fullWidth
                                            value={formikProjectType.values.name}
                                            onBlur={formikProjectType.handleBlur}
                                            onChange={formikProjectType.handleChange}
                                            error={Boolean(formikProjectType.errors?.name && formikProjectType.touched?.name)}
                                            //helperText={!formikProjectType.errors?.name || !formikProjectType.touched?.name ? undefined : t(formikProjectType.errors.name)}
                                        /> :
                                        <Select
                                            id="project-type-select"
                                            name="Project"
                                            size="small"
                                            sx={{ backgroundColor: '#F5F5F5', color: '#07074E' }}
                                            IconComponent={KeyboardArrowDownIcon}
                                            displayEmpty
                                            fullWidth
                                            value={idSelectedProjectType}
                                            disabled={creatingEmptyLayout || showNewElementType || showNewLayout}
                                            onChange={(e: any) => handleChangeProjectTypeSelect(e.target.value)}
                                        >
                                            <MenuItem
                                                value=""
                                                disabled
                                            >
                                                {t("Select")}
                                            </MenuItem>
                                            {projectTypes.map((pro: any, k: number) => (
                                                <MenuItem
                                                    key={pro.idProjectType}
                                                    value={pro.idProjectType}
                                                    className={pro.active == 1 ? "" : "inactive"}
                                                >
                                                    {pro.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    }
                                </Grid>
                                <Grid item xs={12} md={4} >
                                    <Stack direction="row" spacing={2} alignItems="flex-end" justifyContent={matches ? "center" : "flex-end"} >
                                        {isEditingProjectTypeName ?
                                            <>
                                                <TrueffortButton
                                                    id="save-name-change-button"
                                                    size="small"
                                                    //type="submit"
                                                    variant="contained"
                                                    color="indigo"
                                                    disabled={selectedProjectType.name === formikProjectType.values.name}
                                                    startIcon={<EditIcon />}
                                                    onClick={formikProjectType.submitForm}
                                                >
                                                    {t("project_page.change_name")}
                                                </TrueffortButton>

                                                <TrueffortButton
                                                    id="cancel-name-change-button"
                                                    size="small"
                                                    variant="outlined"
                                                    color="error"
                                                    startIcon={<RemoveIcon />}
                                                    onClick={() => {
                                                        formikProjectType.resetForm();
                                                        setIsEditingProjectTypeName(false);
                                                    }}
                                                >
                                                    {t("Cancel")}
                                                </TrueffortButton>
                                            </> :

                                            <>
                                                <TrueffortButton
                                                    id="name-change-button"
                                                    size="small"
                                                    variant="contained"
                                                    color="indigo"
                                                    disabled={!idSelectedProjectType || showNewLayout}
                                                    startIcon={idSelectedProjectType &&!selectedProjectType.active ? <CheckIcon /> : <EditIcon />}
                                                    onClick={() => {
                                                        if (selectedProjectType !== undefined && selectedProjectType.active) {
                                                            formikProjectType.setFieldValue("name", selectedProjectType.name);
                                                            setIsEditingProjectTypeName(true);
                                                        } else {
                                                            reactivateProjectType();
                                                        }
                                                    }}
                                                >
                                                    {idSelectedProjectType && !selectedProjectType.active ? t("project_page.activate_project_type") : t("project_page.change_name")}
                                                </TrueffortButton>

                                                <TrueffortButton
                                                    id="delete-project-type"
                                                    size="small"
                                                    variant="outlined"
                                                    color="cinnabar"
                                                    disabled={!idSelectedProjectType || showNewLayout}
                                                    startIcon={<RemoveIcon />}
                                                    onClick={confirmDeleteProjectType}
                                                >
                                                    {t("project_page.delete_template")}
                                                </TrueffortButton>
                                            </>
                                        }
                                    </Stack>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Paper>
            </Container>

            <Container maxWidth='xl' sx={{ marginTop: '20px' }} >
                <Paper elevation={0} sx={{ padding: '12px', bgcolor: '#F5F5F5' }} >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: matches ? 'flex-start' : "flex-end",
                            justifyContent: 'space-between',
                            marginBottom: '10px',
                            flexDirection: matches ? 'column' : 'row'
                        }}
                    >
                        <Typography  variant='h6' color='#050536' >
                            {t("project_page.template_detail") + (selectedProjectType?.name !== undefined ? " " + selectedProjectType.name : "")}
                        </Typography>

                        {selectedProjectType?.isModifiable && selectedProjectType?.active &&
                            <TrueffortButton
                                id="new-element-type-button"
                                size="small"
                                variant="contained"
                                color="secondary"
                                startIcon={<AddIcon />}
                                onClick={() => setShowNewElementType(true)}
                            >
                                {t("project_page.new_element_type")}
                            </TrueffortButton>
                        }
                    </Box>

                    <Card elevation={1} >
                      <CardContent sx={{ overflowX: 'scroll' }} >
                        {selectedProjectType?.active &&
                          <Box sx={{ minWidth: "1280px" }}>
                            <Paper variant="outlined" square sx={{ padding: '10px', backgroundColor: '#F5F5F5' }} >
                              <Grid container spacing={1} >
                                <Grid item xs={12} >
                                  <Typography sx={{ display: 'flex', alignItems: "center" }} color='#6A6A6A' >
                                    <AppRegistrationIcon fontSize="small" sx={{ marginRight: '6px' }} />
                                    {t("project_page.template") + ": " + selectedProjectType?.name}
                                  </Typography>
                                </Grid>
                                <Grid item xs={0.5} sx={{ textAlign: 'center' }} >
                                  <Typography variant='subtitle2' color='#4A4A4A' >
                                    Nº
                                  </Typography>
                                </Grid>
                                <Grid item xs={10.5} >
                                  <Typography variant='subtitle2' color='#4A4A4A' >
                                    {t("project_page.elem_name_placeholder")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Paper>

                              {elementTypes.map((elemType: any, k: number) =>
                                  <CollapsibleElement
                                      key={elemType.idElementType.toString()}
                                      t={t}
                                      elementType={elemType}
                                      index={k}
                                      fillElementTypes={fillElementTypes}
                                      elementTypeService={elementTypeService}
                                      isModifiable={selectedProjectType?.isModifiable}
                                  />
                              )}

                              <Paper
                                  component="form"
                                  onSubmit={formikNewElementType.handleSubmit}
                                  variant="outlined"
                                  square
                                  sx={{ padding: '10px' }}
                              >
                                  <Grid container spacing={1} alignItems="center" justifyContent="center"  >
                                      {showNewElementType &&
                                          <Grid item xs={0.5} sx={{ textAlign: 'center' }} >
                                              {elementTypes.length + 1}
                                          </Grid>
                                      }
                                      <Grid item xs={showNewElementType ? 11.5 : 12} >
                                          <Stack direction="row" spacing={2} alignItems="center" >
                                              {showNewElementType ?
                                                  <>
                                                      <IconButton
                                                          aria-label="expand row"
                                                          size="small"
                                                          disabled
                                                      >
                                                          <ArrowRightIcon />
                                                      </IconButton>

                                                      <TrueffortTextField
                                                          name="name"
                                                          size="small"
                                                          required
                                                          placeholder={t("project_tasks_page.new_element") + "..."}
                                                          disabled={formikNewElementType.isSubmitting}
                                                          onBlur={formikNewElementType.handleBlur}
                                                          onChange={formikNewElementType.handleChange}
                                                          error={Boolean(formikNewElementType.errors?.name && formikNewElementType.touched?.name)}
                                                      />

                                                      <Chip
                                                          sx={{ borderRadius: '3px' }}
                                                          icon={<FontAwesomeIcon icon={faFolderTree} color={'#68C8BA'} />}
                                                          label={"0 " + t("home.phases")}
                                                          variant='outlined'
                                                      />

                                                      <Chip
                                                          icon={<AddIcon fontSize="small" />}
                                                          label={t("project_page.save_new_element_type")}
                                                          variant="outlined"
                                                          color="success"
                                                          onClick={formikNewElementType.submitForm}
                                                      />

                                                      <Chip
                                                          icon={<CancelIcon fontSize="small" />}
                                                          label={t("Cancel")}
                                                          variant="outlined"
                                                          color='redExtra'
                                                          onClick={() => setShowNewElementType(false)}
                                                      />
                                                  </> :

                                                  <TrueffortChip
                                                      icon={<AddIcon fontSize="small" />}
                                                      label={t("project_page.new_element_type")}
                                                      variant="outlined"
                                                      onClick={() => setShowNewElementType(true)}
                                                  />
                                              }
                                          </Stack>
                                      </Grid>
                                  </Grid>
                              </Paper>
                          </Box>
                        }
                      </CardContent>

                      <CardActions >
                          <Box sx={{ padding: '12px', display: 'flex', justifyContent: "flex-end" }} >
                              <TrueffortButton
                                  id="duplicate-button"
                                  variant="outlined"
                                  disabled={idSelectedProjectType == "" || showNewLayout}
                                  onClick={() => setShowNewLayout(true)}
                              >
                                  {t("project_page.duplicate")}
                              </TrueffortButton>
                          </Box>
                      </CardActions>
                    </Card>
                </Paper>
            </Container>
        </SiteWrapper>
    );
}

export default ProjectTypesPage;